import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  createAppUser: boolean;
}

export const createAppUser = async <V>(
  apollo: DollarApollo<V>,
  args: { name: string; groupId: string; start: number; end: number }
): Promise<FetchResult<RawResult>> => {
  const { name, groupId, start, end } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: { name, groupId, start, end },
    update(_proxy, data): string {
      return data.data!.createAppUser + "";
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
